export default {
  list: [
    {
      title: 'مجرد',
      value: 'SINGLE'
    },
    {
      value: 'MARRIED',
      title: 'متاهل'
    }
  ],
  values: {
    COUPLE: 'MARRIED',
    SINGLE: 'SINGLE'
  }
};
